export function redondearCentavos(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

export function usdDesdePesos(pesos, cotizacion) {
  const c = Number(cotizacion);
  if (!(c > 0)) return null;
  return redondearCentavos(Number(pesos) / c);
}

export function pesosDesdeUsd(usd, cotizacion) {
  const c = Number(cotizacion);
  if (!(c > 0)) return null;
  return redondearCentavos(Number(usd) * c);
}

function redondear4(n) {
  return Math.round((Number(n) + Number.EPSILON) * 10000) / 10000;
}

export function cotizacionImplicita(pesos, usd) {
  const p = Number(pesos);
  const u = Number(usd);
  if (!(u > 0) || !(p > 0) || !Number.isFinite(p) || !Number.isFinite(u)) return null;
  return redondear4(p / u);
}

export function tieneMontoCargado(v) {
  if (v == null || String(v).trim() === '') return false;
  const n = Number(String(v).replace(',', '.'));
  return Number.isFinite(n);
}

export function aplicarCambioMontoUsd(actual, campo, value, cotizBna) {
  const editandoPesos = campo === 'pesos';
  const otro = editandoPesos ? actual.monto_usd : actual.monto;
  const vieneDelOtro = editandoPesos
    ? actual.moneda_ingresada === 'USD'
    : actual.moneda_ingresada === 'ARS';
  const modoAmbos = actual.moneda_ingresada === 'AMBOS'
    || (tieneMontoCargado(otro) && vieneDelOtro);

  const next = {
    ...actual,
    ultimo_origen: editandoPesos ? 'ARS' : 'USD',
  };

  if (modoAmbos) {
    if (editandoPesos) next.monto = value;
    else next.monto_usd = value;
    next.moneda_ingresada = 'AMBOS';
    const implicita = cotizacionImplicita(next.monto, next.monto_usd);
    if (implicita != null) next.cotizacion = implicita;
    return next;
  }

  if (editandoPesos) {
    const usd = cotizBna ? usdDesdePesos(value, cotizBna) : null;
    next.moneda_ingresada = 'ARS';
    next.monto = value;
    next.monto_usd = usd == null ? next.monto_usd : String(usd);
    next.cotizacion = cotizBna;
    return next;
  }

  const pesos = cotizBna ? pesosDesdeUsd(value, cotizBna) : null;
  next.moneda_ingresada = 'USD';
  next.monto_usd = value;
  next.monto = pesos == null ? next.monto : String(pesos);
  next.cotizacion = cotizBna;
  return next;
}

export function aplicarBnaALinea(fp, cotiz) {
  if (!(cotiz > 0)) return fp;
  const origen = fp.ultimo_origen === 'USD' || fp.moneda_ingresada === 'USD' ? 'USD' : 'ARS';
  const next = { ...fp, moneda_ingresada: origen, cotizacion: cotiz };
  if (origen === 'USD' && tieneMontoCargado(fp.monto_usd)) {
    const pesos = pesosDesdeUsd(fp.monto_usd, cotiz);
    if (pesos != null) next.monto = String(pesos);
    return next;
  }
  if (tieneMontoCargado(fp.monto)) {
    const usd = usdDesdePesos(fp.monto, cotiz);
    if (usd != null) next.monto_usd = String(usd);
  }
  return next;
}

export function textoTasaUsada(fp, { puntaLabel, textoBna, valorBna }) {
  const usada = Number(fp?.cotizacion);
  if (fp?.moneda_ingresada !== 'AMBOS' || !(usada > 0)) return textoBna;
  const fmtUsada = usada.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  });
  const bna = Number(valorBna);
  if (bna > 0 && Math.abs(usada - bna) > 0.00005) {
    const fmtBna = bna.toLocaleString('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4,
    });
    return `Cotización usada: ${fmtUsada} (BNA ${puntaLabel}: ${fmtBna}). El total del comprobante suma los pesos.`;
  }
  return `Cotización usada: ${fmtUsada}. El total del comprobante suma los pesos.`;
}

export function monedaDestinoLinea(fp, { formasPago = [], cuentasBancarias = [], cajas = [], modoEgreso = false } = {}) {
  const forma = formasPago.find((f) => String(f.id) === String(fp?.forma_pago_id));
  const nombre = (forma?.nombre || '').toLowerCase();
  if (nombre.includes('transferencia')) {
    const cuentaId = fp?.transferencia?.cuenta_bancaria_id ?? forma?.destino_cuenta_id ?? forma?.cuenta_bancaria_id;
    const cuenta = cuentasBancarias.find((c) => String(c.id) === String(cuentaId));
    if (cuenta?.moneda) return String(cuenta.moneda).trim().toUpperCase();
  }
  if (modoEgreso && nombre.includes('cheque propio') && !nombre.includes('cheque de tercero')) {
    const cuenta = cuentasBancarias.find((c) => String(c.id) === String(fp?.cheque_propio?.cuenta_bancaria_id));
    if (cuenta?.moneda) return String(cuenta.moneda).trim().toUpperCase();
  }
  if (fp?.caja_id) {
    const caja = cajas.find((c) => String(c.id) === String(fp.caja_id));
    if (caja?.moneda) return String(caja.moneda).trim().toUpperCase();
  }
  return String(forma?.destino_moneda || 'ARS').trim().toUpperCase() || 'ARS';
}

export function esDestinoUsd(fp, ctx) {
  return monedaDestinoLinea(fp, ctx) === 'USD';
}

export function camposDolar(fp, ctx) {
  if (!esDestinoUsd(fp, ctx)) return {};
  return {
    monto_usd: parseFloat(fp.monto_usd),
    cotizacion: parseFloat(fp.cotizacion),
  };
}
